"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
const ApiFileReference_1 = require("./ApiFileReference");
class Client {
    constructor({ endpoint, axiosInstance }) {
        this.getFile = (fileReferenceId, token, config = {}) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance.request(Object.assign(Object.assign({ url: `${this.endpoint}/files/${fileReferenceId}/detail?token=${token}`, method: 'get' }, config), { withCredentials: false }));
            if (response.status !== 200) {
                throw new Error();
            }
            const json = yield response.data;
            return ApiFileReference_1.default.fromJSON(json);
        });
        this.getAllFilesInBucket = (bucketId, token, config = {}) => __awaiter(this, void 0, void 0, function* () {
            const tokenParam = token != null ? `?token=${token}` : '';
            const response = yield this.axiosInstance.request(Object.assign(Object.assign({ url: `${this.endpoint}/buckets/${bucketId}/files${tokenParam}`, method: 'get' }, config), { withCredentials: token == null }));
            if (response.status !== 200) {
                throw new Error();
            }
            const json = yield response.data;
            return json.map((item) => ApiFileReference_1.default.fromJSON(item));
        });
        this.uploadFile = (file, bucketId, organizationId, config = {}) => __awaiter(this, void 0, void 0, function* () {
            let url = `${this.endpoint}/buckets/${bucketId}/files`;
            if (organizationId) {
                url += `?org=${organizationId}`;
            }
            const response = yield this.axiosInstance.request(Object.assign({ url: url, method: 'POST', data: file, headers: {
                    // Please do not set the 'content-length'. This is set automatically by axios.
                    'content-type': file.type,
                    'content-name': encodeURIComponent(file.name),
                } }, config));
            if (response.status !== 200) {
                throw new Error();
            }
            const json = yield response.data;
            return ApiFileReference_1.default.fromJSON(json);
        });
        this.deleteFile = (fileReferenceId, bucketId, config = {}) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axiosInstance.request(Object.assign({ url: `${this.endpoint}/buckets/${bucketId}/files/${fileReferenceId}`, method: 'DELETE' }, config));
            if (response.status !== 204) {
                throw new Error();
            }
            return;
        });
        axios_1.default.defaults.withCredentials = true;
        this.endpoint = endpoint;
        this.axiosInstance =
            axiosInstance ||
                axios_1.default.create({
                    baseURL: endpoint,
                    withCredentials: true,
                });
    }
}
exports.default = Client;
